import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightShow16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSidebarRightShow16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3h-2v10h2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1M3 3h7v10H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m0-1a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4.19 4.232a.5.5 0 0 0-.707-.707L4.362 7.646 4.008 8l.354.354 2.12 2.12a.5.5 0 0 0 .708-.706L5.422 8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightShow16);
